import React from "react";

import { Select as CobaltSelect } from "Cobalt/Select";
import CommonSelect from "Common/forms/SIFormSelect";

import { useThemeContext } from "./Context";

export type SelectProps = {
  className?: string;
  placeholder?: string;
  // Either { [label]: value } or Array<[value, label]>.  Array form is
  // preferred because it is ordered and allows React.Node as the label.
  options: Record<string, string> | Array<[any, any]>;
  name: string;
  input?: React.ElementProps<"select"> & { value?: string };
  meta?: { touched: boolean; error?: any; warning?: any };
  disabled?: boolean;
  noPlaceholder?: boolean;
  children?: React.ReactNode;
};

export const Select = (props: SelectProps) => {
  const { intuit, cobalt } = useThemeContext();
  const showCobalt = cobalt && !intuit;
  const SelectComponent = showCobalt ? CobaltSelect : CommonSelect;

  return <SelectComponent {...props} />;
};
